"use strict";

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { onReady } from '../core/ready.js';

Swiper.use([Navigation]);

onReady(() => {
    initCasesSlider();
});

function initCasesSlider() {
    const swiperCaseSliders = document.querySelectorAll('.case-slider');

    if (swiperCaseSliders && swiperCaseSliders.length) {
        swiperCaseSliders.forEach((sliderEl) => {
            const nextEl = sliderEl.querySelector('.swiper-button-next');
            const prevEl = sliderEl.querySelector('.swiper-button-prev');
            new Swiper(sliderEl, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: false,
                navigation: {
                    enabled: Boolean(nextEl && prevEl),
                    nextEl,
                    prevEl
                },
                breakpoints: {
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    }
                }
            });
        });
    }

}